const ContractIdGForm = [
    { id: 'PMD_1', name: 'Серцево-судинні та цереброваскулярні захворювання, цукровий діабет 2-го типу та хронічні хвороби нижніх дихальних шляхів'},
    { id: 'INSULIN_1', name: 'Інсуліни' },
    { id: 'ND_1', name: 'Нецукровий діабет' },
    { id: 'PSYCHIATRY', name: 'Розлади психіки та поведінки. Епілепсія' },
    { id: 'GENERAL', name: 'Загальний договір' }
];

export default ContractIdGForm;